import React, { useState } from 'react';
import {
    Box,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TextField,
    Button,
    Typography,
    Paper,
} from '@mui/material';

const CommonEditableTable = ({ title, data, editable, onSave, onCancel }) => {
    const [tableData, setTableData] = useState(data);

    const handleInputChange = (rowIndex, colKey, value) => {
        const updatedData = [...tableData];
        updatedData[rowIndex][colKey] = value;
        setTableData(updatedData);
    };

    return (
        <Box sx={{ mb: 2 }}>
            <TableContainer component={Paper} elevation={2}>
                <Table size="small" sx={{ border: '1px solid #ccc' }}>
                    <TableHead>
                        <TableRow>
                            {Object.keys(tableData[0] || {}).map((colKey, colIndex) => (
                                <TableCell
                                    key={colIndex}
                                    sx={{
                                        backgroundColor: '#49A3FF',
                                        color: '#fff',
                                        fontWeight: 'bold',
                                        border: '1px solid #ccc',
                                    }}
                                >
                                    {colKey}
                                </TableCell>
                            ))}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {tableData.map((row, rowIndex) => (
                            <TableRow key={rowIndex}>
                                {Object.entries(row).map(([key, value], colIndex) => (
                                    <TableCell
                                        key={colIndex}
                                        sx={{ border: '1px solid #ccc', verticalAlign: 'top' }}
                                    >
                                        {editable ? (
                                            <TextField
                                                value={value}
                                                onChange={(e) =>
                                                    handleInputChange(rowIndex, key, e.target.value)
                                                }
                                                fullWidth
                                                multiline
                                                variant="outlined"
                                                size="small"
                                                sx={{
                                                    '& .MuiOutlinedInput-root': {
                                                        backgroundColor: '#fff',
                                                    },
                                                }}
                                            />
                                        ) : (
                                            <Typography variant="body2">{value}</Typography>
                                        )}
                                    </TableCell>
                                ))}
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>

            {editable && (
                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'flex-end',
                        mt: 1,
                        gap: 1,
                    }}
                >
                    <Button
                        variant="text"
                        onClick={onCancel}
                        size="small"
                        sx={{
                            textTransform: 'none',
                            color: '#49A3FF',
                            '&:hover': {
                                backgroundColor: 'rgba(73, 163, 255, 0.08)' 
                            }
                        }}
                    >
                        Cancel
                    </Button>

                    <Button
                        variant="contained"
                        onClick={() => onSave(tableData)}
                        size="small"
                        sx={{
                            textTransform: 'none',
                            backgroundColor: '#49A3FF',
                            color: '#fff', 
                            '&:hover': {
                                backgroundColor: '#1E90FF' 
                            }
                        }}
                    >
                        Save
                    </Button>

                </Box>
            )}
        </Box>
    );
};

export default CommonEditableTable;
